import {useMutation} from '@tanstack/react-query';
import {PostRequestPreRegisterParams} from 'domain/usecases/others/facial-biometric';
import {postPreRegister} from '../services/postPreRegister';

export const usePreRegisterMutation = () =>
	useMutation({
		mutationFn: (params: PostRequestPreRegisterParams) => postPreRegister(params),
	});
